import type { BenchmarkControllers } from "app/pages/benchmark-tracker/config";
import { BenchmarkMetricName } from "app/pages/benchmark-tracker/types/api.types";

export const METRICS_BY_CONTROLLER: Record<BenchmarkControllers, BenchmarkMetricName[]> = {
    overview: [BenchmarkMetricName.trafficShare, BenchmarkMetricName.visits, BenchmarkMetricName.audienceReach],
    engagement: [
        BenchmarkMetricName.visitDuration,
        BenchmarkMetricName.bounceRate,
        BenchmarkMetricName.pagesPerVisit,
        BenchmarkMetricName.pageViews,
    ],
};
